module.exports = __webpack_public_path__ + "static/media/profile-active.fe180d0e.png";